import { isIos, isMobile, isMobileAndTablet, isSafari } from '@/utils/browser'

export const IS_MOBILE = isMobile()

export const IS_MOBILE_AND_TABLET = isMobileAndTablet()

export const IS_IOS = isIos()

export const IS_SAFARI = isSafari()
